// @oasis-permission-public: Same data and backend employee authorization as Basecamp Style Reviews; the dashboard session and backend employee check remain required.
import { createFileRoute } from "@tanstack/react-router";

import { ensureSession } from "~/modules/auth/credentials";
import { BasecampRunInspectorPage } from "~/modules/basecamp-run-inspector/basecamp-run-inspector-page";
import { inspectorSearchSchema } from "~/modules/basecamp-run-inspector/schemas";

export const Route = createFileRoute("/_dash/basecamp-run-inspector")({
  validateSearch: inspectorSearchSchema,
  beforeLoad() {
    ensureSession();
  },
  component: BasecampRunInspectorPage,
});
